"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadExportFile = downloadExportFile;
exports.exportCardDetail = exportCardDetail;
exports.exportCardTransactions = void 0;
exports.exportTransactionDetail = exportTransactionDetail;
exports.getCardDetail = getCardDetail;
exports.getCardDetailById = getCardDetailById;
exports.getCardDetailList = getCardDetailList;
exports.getCardList = getCardList;
exports.getCardTransactions = getCardTransactions;
exports.getCustomerList = getCustomerList;
exports.getMiniappList = getMiniappList;
exports.getProjectList = getProjectList;
exports.getTransactionTypes = getTransactionTypes;
exports.updateCardPhone = updateCardPhone;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取卡片交易明细列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
function getCardDetailList(params) {
  return (0, _request.default)({
    url: '/admin/card/transaction/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取卡片交易详情
 * @param {string|number} id 交易ID
 * @returns {Promise}
 */
function getCardDetailById(id) {
  return (0, _request.default)({
    url: "/admin/card/transaction/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 导出福卡明细
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
function exportCardDetail(params) {
  return (0, _request.default)({
    url: '/admin/fudou/card/record/card/export',
    method: 'get',
    params: params
  });
}

/**
 * 导出收支明细（通过后端返回的fileName，再带Token请求文件内容并Blob下载）
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
function exportTransactionDetail(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/fudou/card/record/log/export',
    method: 'get',
    params: params
  });
}

/**
 * 带Token下载导出文件（通过后端download接口，Blob方式）
 * @param {string} fileName 文件相对路径（后端导出接口返回的fileName）
 * @returns {Promise<Blob>}
 */
function downloadExportFile(fileName) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/fudou/card/record/download',
    method: 'get',
    params: {
      fileName: fileName
    },
    responseType: 'blob'
  });
}

// 保留原有函数名以保持兼容性
var exportCardTransactions = exports.exportCardTransactions = exportTransactionDetail;

/**
 * 获取卡片交易类型下拉选项
 * @returns {Promise}
 */
function getTransactionTypes() {
  return (0, _request.default)({
    url: '/admin/card/transaction/types',
    method: 'get'
  });
}

/**
 * 获取卡片详情
 * @param {string|number} empIntegralId - 卡片ID
 */
function getCardDetail(empIntegralId) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/card/record/card/detail',
    url: '/mapi/asset/fudou/card/record/card/detail',
    method: 'get',
    params: {
      id: empIntegralId
    }
  });
}

/**
 * 获取卡片收支明细列表
 * @param {Object} params - 查询参数，包含cardId、page、limit等
 */
function getCardTransactions(params) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/card/record/log/index',
    url: '/mapi/asset/fudou/card/record/log/index',
    method: 'get',
    params: params
  });
}

/**
 * 获取客户列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
function getCustomerList(params) {
  return (0, _request.default)({
    url: '/admin/customer/select',
    method: 'get',
    params: params
  });
}

/**
 * 获取小程序列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
function getMiniappList(params) {
  // return request({
  //   url: '/admin/companyapp/autoList',
  //   method: 'get',
  //   params: params || { keyword: '' }
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params || {
      keyword: ''
    }
  });
}

/**
 * 获取项目列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
function getProjectList(params) {
  return (0, _request.default)({
    url: '/admin/fudou/project/select',
    method: 'get',
    params: params
  });
}

/**
 * 修改福卡绑定手机号
 */
function updateCardPhone(data) {
  return (0, _request.default)({
    url: '/admin/welfare/card/update/phone',
    method: 'POST',
    data: data
  });
}

/**
 * 获取福卡列表
 */
function getCardList(params) {
  return (0, _requestMapi.default)({
    //url: '/admin/fudou/card/record/card/index',
    url: '/mapi/asset/fudou/card/record/card/index',
    method: 'get',
    params: params
  });
}